// import 'babel-polyfill';
import Vue from 'vue';
import Vuex from 'vuex';
import loading from './modules/loading';
import loginInfo from './modules/login_info';
import holidays from './modules/holidays';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    loading,
    loginInfo,
    holidays,
  },
});

export default store;
